import { axiosInstance } from '.'
import { GET_WEBINARS } from './endpoints'

export const webinarServices = {
  getWebinars: async (params: { [key: string]: string }, headers: { [key: string]: string }) => {
    try {
      const res = await axiosInstance.get(GET_WEBINARS, {
        headers: headers,
        params: params,
      })
      return res.data
    } catch (error: unknown) {
      if (error && typeof error === 'object' && 'response' in error) {
        return (error as { response: unknown }).response
      }
      return error
    }
  },
}
